function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 19.5c-.842 0-1.685-.178-2.504-.495M20.882 12.968C18.99 16.467 15.495 19.5 12 19.5M19.078 9.42a15.135 15.135 0 011.803 2.613.987.987 0 010 .935M5 19.5l14-14M9.772 14.727a3.15 3.15 0 014.455-4.455",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.044 7.456C15.497 6.259 13.748 5.5 12 5.5c-3.495 0-6.99 3.033-8.882 6.533a.987.987 0 000 .935c.946 1.749 2.292 3.381 3.838 4.577",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgEyeClosed;